//import {getEwGroups} from '../enterworks'
import axios from 'axios'
import { showSpinner, hideSpinner } from '../../FTPMgt/action/SpinnerActions'
import { fetchEwCompanies, clearCos } from './ewCompanyActions'
import { fetchEwGroups, clearGroups } from './ewGroupActions'

export const CREATE_IMPS_BEGIN = "CREATE_IMPS_BEGIN"
export const CREATE_IMPS_SUCCESS = "CREATE_IMPS_SUCC"
export const CREATE_IMPS_FAIL = "CREATE_IMPS_FAIL"

export const CREATE_USER_BEGIN = "CREATE_USER_BEGIN"
export const CREATE_USER_SUCCESS = "CREATE_USER_SUCCESS"
export const CREATE_USER_FAILURE = "CREATE_USER_FAILURE"


export const UPDATE_USER_BEGIN = "UPDATE_USER_BEGIN"
export const UPDATE_USER_SUCCESS = "UPDATE_USER_SUCCESS"
export const UPDATE_USER_FAILURE = "UPDATE_USER_FAILURE"

export const FETCH_USERS_BEGIN = "FETCH_USERS_BEGIN"
export const FETCH_USERS_SUCCESS = "FETCH_USERS_SUCCESS"
export const FETCH_USERS_FAILURE = "FETCH_USERS_FAILURE"

export const FETCH_ROLES_BEGIN = "FETCH_ROLES_BEGIN"
export const FETCH_ROLES_SUCCESS = "FETCH_ROLES_SUCCESS"
export const FETCH_ROLES_FAILURE = "FETCH_ROLES_FAILURE"

export const ADD_USER_ROLE = "ADD_USER_ROLE"
export const REMOVE_USER_ROLE = "REMOVE_USER_ROLE"

export const CLEAR_ROLES = "CLEAR_ROLES"

export const FILTER_USERS_BEGIN = 'FILTER_USERS_BEGIN'
export const FILTER_USERS_SUCCESS = 'FILTER_USERS_SUCCESS'
export const FILTER_USERS_FAIL = 'FILTER_USERS_FAIL'

export const DELETE_USER_BEGIN = 'DELETE_USER_BEGIN'
export const DELETE_USER_SUCCESS = 'DELETE_USER_SUCCESS'
export const DELETE_USER_FAIL = 'DELETE_USER_FAIL'

export const SELECT_USER = 'SELECT_USER'
export const DESELECT_USER = 'DESLECT_USER'

export const RESET_PASSWORD_BEGIN = 'RESET_PASSWORD_BEGIN'
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS'
export const RESET_PASSWORD_FAIL = 'RESET_PASSWORD_FAIL'

export const LOGIN_BEGIN = "LOGIN_BEGIN"
export const LOGIN_SUCCESS = "LOGIN_SUCCESS"
export const LOGIN_FAIL = "LOGIN_FAIL"

export const CLEAR_PW_RESULT = "CLEAR_PW_RESULT"
export const CLEAR_LOGIN_RESULT = "CLEAR_LOGIN_RESULT"

export const VALIDATE_PW_TOKEN_BEGIN = 'VALIDATE_PW_TOKEN_BEGIN'
export const VALIDATE_PW_TOKEN_SUCCESS = 'VALIDATE_PW_TOKEN_SUCCESS'
export const VALIDATE_PW_TOKEN_FAIL = 'VALIDATE_PW_TOKEN_FAIL'

export const SEND_PASS_EMAIL_BEGIN = "SEND_PASS_EMAIL_BEGIN"
export const SEND_PASS_EMAIL_SUCCESS = "SEND_PASS_EMAIL_SUCCESS"
export const SEND_PASS_EMAIL_FAIL = "SEND_PASS_EMAIL_FAIL"

export const UPLOAD_USERS_BEGIN = "UPLOAD_USERS_BEGIN"
export const UPLOAD_USERS_SUCCESS = "UPLOAD_USERS_SUCCESS"
export const UPLOAD_USERS_FAIL = "UPLOAD_USERS_FAIL"

export const GET_LOGGED_IN_USER_BEGIN = "GET_LOGGED_IN_USER_BEGIN"
export const GET_LOGGED_IN_USER_SUCCESS = "GET_LOGGED_IN_USER_SUCCESS"
export const GET_LOGGED_IN_USER_FAIL = "GET_LOGGED_IN_USER_FAIL"

export const GET_CONFIG_BEGIN = "GET_CONFIG_BEGIN"
export const GET_CONFIG_SUCCESS = "GET_CONFIG_SUCCESS"
export const GET_CONFIG_FAIL = "GET_CONFIG_FAIL"

export const NAVIGATE_PAGE = "NAVIGATE_PAGE"


function generateImpersonations() {
  return fetch("/iframeApi/createImpersonations")
    .then(handleErrors)
    .then(res => res.json());
}

function getEwUsers() {
  return fetch("/iframeApi/getUsers")
    .then(handleErrors)
    .then(res => res.json());
}

function fetchConfig() {
  return fetch('/iframeApi/config')
    .then(handleErrors)
    .then(res => res.json())
}


async function getUserInfo() {
  var result = await axios.get('/iframeApi/loggedInUser')
  return result.data
}

async function getFilteredUsers(input) {
  console.log('input for filterusers', input)
  var fUsers = []
  if (input.context == 'IDEA') {
    fUsers = input.allUsers.filter(user => {
      return user.idea
    })
    console.log(fUsers)
  } else {
    fUsers = input.allUsers.filter(user => {

      return (user.securityContextValue == input.context || user.Contexts.includes(input.context) && !user.idea)
    })
  }

  input.allUsers = fUsers

  var result = await axios.post("/iframeApi/user", input)

  console.log('filtered users ', result.data)
  return result.data
}

async function createEwUser(input) {
  var result = await axios.post("/iframeApi/createUser", input)
  console.log(result)
  if (result.data.error) {
    throw new Error(result.data.error)
  }
  return result.data
}

async function uploadUserFile(file) {
  var formData = new FormData();
  formData.append('users', file)
  var result = await axios.post('/iframeApi/uploadUsers', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
  return result.data
}

async function updateEwUser(input) {
  var result = await axios.post("/iframeApi/updateuser", input)
  if (result.data.error) {
    throw new Error(result.data.error)
  }
  return result.data
}

async function deleteEwUser(input) {
  var result = await axios.post("/iframeApi/deleteUser", input)
  return result.data
}

async function getUserRoles(input) {

  if (input.idea)
    return [{ userId: input.userId, securityContextValue: input.securityContextValue, groupName: input.groupName, groupId: input.groupId }]

  var result = await axios.get("/iframeApi/userRoles/" + input.userId)
  return result.data
}

async function resetAdPassword(input) {
  var result = await axios.post("/iframeApi/resetpassword", input)
  return result.data
}

async function loginAd(input) {
  var result = await axios.post("/iframeApi/login", input)
  return result.data
}

async function validatePwToken(input) {
  var result = await axios.post("/iframeApi/validatetoken", { token: input })
  return result.data
}

async function sendPasswordEmail(input) {
  var result = await axios.post("/iframeApi/sendemailpw", input)
  return result.data
}


const createImpsBegin = () => ({
  type: CREATE_IMPS_BEGIN
})

const createImpsSuccess = impersonations => ({
  type: CREATE_IMPS_SUCCESS,
  payload: { impersonations }
})


const createImpsFail = error => ({
  type: CREATE_IMPS_FAIL,
  payload: { error }
})

const getConfigBegin = () => ({
  type: GET_CONFIG_BEGIN
})

const getConfigSuccess = config => ({
  type: GET_CONFIG_SUCCESS,
  payload: { config }
})

const getConfigFail = error => ({
  type: GET_CONFIG_FAIL,
  payload: { error }
})



const nPage = page => ({
  type: NAVIGATE_PAGE,
  payload: { page }
})

const cRoles = (leaveOne) => ({
  type: CLEAR_ROLES,
  payload: { leaveOne }
})

const validateTokenBegin = () => ({
  type: VALIDATE_PW_TOKEN_BEGIN
})

const uploadUserBegin = () => ({
  type: UPLOAD_USERS_BEGIN
})

const uploadUsersSuccess = result => ({
  type: UPLOAD_USERS_SUCCESS,
  payload: { result }
})

const uploadUsersFail = error => ({
  type: UPLOAD_USERS_FAIL,
  payload: { error }
})

const sendPwEmailBegin = () => ({
  type: SEND_PASS_EMAIL_BEGIN
})

const sendPwEmailSuccess = result => ({
  type: SEND_PASS_EMAIL_SUCCESS,
  payload: { result }
})

const sendPwEmailFail = error => ({
  type: SEND_PASS_EMAIL_FAIL,
  payload: { error }
})

const validateTokenSuccess = result => ({
  type: VALIDATE_PW_TOKEN_SUCCESS,
  payload: { result }
})


const validateTokenFail = error => ({
  type: VALIDATE_PW_TOKEN_FAIL,
  payload: { error }
})

const clearRes = () => ({
  type: CLEAR_PW_RESULT
})

const clearLog = () => ({
  type: CLEAR_LOGIN_RESULT
})

const loginBegin = () => ({
  type: LOGIN_BEGIN
})

const loginSuccess = result => ({
  type: LOGIN_SUCCESS,
  payload: { result }
})


const loginFail = error => ({
  type: LOGIN_FAIL,
  payload: { error }
})

const resetPasswordBegin = () => ({
  type: RESET_PASSWORD_BEGIN
})


const resetPasswordSuccess = result => ({
  type: RESET_PASSWORD_SUCCESS,
  payload: { result }
})


const resetPasswordFail = error => ({
  type: RESET_PASSWORD_BEGIN,
  payload: { error }
})

const remRole = role => ({
  type: REMOVE_USER_ROLE,
  payload: { role }
})

const aRole = type => ({
  type: ADD_USER_ROLE,
  payload: { type }
})

const selectUser = user => ({
  type: SELECT_USER,
  payload: { user }
})
const delesctUser = () => ({
  type: DESELECT_USER
})

const delUserBegin = () => ({
  type: DELETE_USER_BEGIN
})

const delUserSuccess = result => ({
  type: DELETE_USER_SUCCESS,
  payload: { result }
})

const delUserFail = error => ({
  type: DELETE_USER_FAIL,
  payload: { error }
})

const filterUsersBegin = () => ({
  type: FILTER_USERS_BEGIN
})

const filterUsersSuccess = filteredUsers => ({
  type: FILTER_USERS_SUCCESS,
  payload: { filteredUsers }
})

const filterUsersFail = error => ({
  type: FILTER_USERS_FAIL,
  payload: { error }
})


const fetchUsersBegin = () => ({
  type: FETCH_USERS_BEGIN
});

const fetchUsersSuccess = users => ({
  type: FETCH_USERS_SUCCESS,
  payload: { users }
});

const fetchUsersFailure = error => ({
  type: FETCH_USERS_FAILURE,
  payload: { error }
});


const fetchRolesBegin = () => ({
  type: FETCH_ROLES_BEGIN
});

const fetchRolesSuccess = roles => ({
  type: FETCH_ROLES_SUCCESS,
  payload: { roles }
});

const fetchRolesFailure = error => ({
  type: FETCH_ROLES_FAILURE,
  payload: { error }
});

const updateUserBegin = () => ({
  type: UPDATE_USER_BEGIN
});

const updateUserSuccess = result => ({
  type: UPDATE_USER_SUCCESS,
  payload: { result }
});

const updateUserFailure = error => ({
  type: UPDATE_USER_FAILURE,
  payload: { error }
});

const createUserBegin = () => ({
  type: CREATE_USER_BEGIN
});

const createUserSuccess = result => ({
  type: CREATE_USER_SUCCESS,
  payload: { result }
});

const createUserFailure = error => ({
  type: CREATE_USER_FAILURE,
  payload: { error }
});

const getLoggedInUserBegin = () => ({
  type: GET_LOGGED_IN_USER_BEGIN
})

const getLoggedInUserSuccess = result => ({
  type: GET_LOGGED_IN_USER_SUCCESS,
  payload: { result }
})

const getLoggedInUserFail = error => ({
  type: GET_LOGGED_IN_USER_FAIL,
  payload: { error }
})

export function navigatePage(page) {
  return nPage(page)
}

export function clearRoles(leaveOne) {
  return cRoles(leaveOne)
}

export function removeRole(role) {
  return remRole(role)
}

export function addRole(type) {
  return aRole(type)
}

export function clearResult() {
  return clearRes()
}

export function clearLoginResult() {
  return clearLog()
}

export function selectEwUser(user) {
  return selectUser(user)
}
export function deslectEwUser() {
  return delesctUser()
}

export function requestPwEmail(input) {
  return dispatch => {
    dispatch(sendPwEmailBegin());
    return sendPasswordEmail(input)
      .then(json => {
        dispatch(sendPwEmailSuccess(json));
        return json;
      })
      .catch(error =>
        dispatch(sendPwEmailFail(error))
      );
  };
}

export function filterUsers(input) {
  return dispatch => {
    dispatch(filterUsersBegin());
    return getFilteredUsers(input)
      .then(json => {
        dispatch(filterUsersSuccess(json));
        return json;
      })
      .catch(error =>
        dispatch(filterUsersFail(error))
      );
  };
}

export function getUsers() {
  return dispatch => {
    dispatch(fetchUsersBegin());
    return getEwUsers()
      .then(json => {
        dispatch(fetchUsersSuccess(json));
        return json;
      })
      .catch(error => {
        console.log('error in users', error)
        dispatch(fetchUsersFailure(error))
      }

      );
  };
}

export function createImpersonations() {
  return dispatch => {
    dispatch(createImpsBegin());
    return generateImpersonations()
      .then(json => {
        console.log('imps rsult', json)
        dispatch(createImpsSuccess(json));
        return json;
      })
      .catch(error => {
        console.log('error in creating imps', error)
        dispatch(createImpsFail(error))
      }

      );
  };
}

export function getConfig() {
  return dispatch => {
    dispatch(getConfigBegin());
    return fetchConfig()
      .then(json => {
        dispatch(getConfigSuccess(json));
        return json;
      })
      .catch(error =>
        dispatch(getConfigFail(error))
      );
  };
}

export function getLoggedInUser() {
  return dispatch => {
    dispatch(getLoggedInUserBegin());
    return getUserInfo()
      .then(json => {
        dispatch(getLoggedInUserSuccess(json));
        return json;
      })
      .catch(error =>
        dispatch(getLoggedInUserFail(error))
      );
  };
}

export function getRoles(user) {
  return dispatch => {
    dispatch(fetchRolesBegin());
    if (user.serviceAccount) {
      let role = [{ securityContextValue: user.securityContextValue, groupId: 0, groupName: 'sa' }]
      dispatch(fetchRolesSuccess(role))
      return role
    } else {
      return getUserRoles(user)
        .then(json => {
          dispatch(fetchRolesSuccess(json));
          return json;
        })
        .catch(error =>
          dispatch(fetchRolesFailure(error))
        );
    }

  };
}

export function login(input) {
  return dispatch => {
    dispatch(loginBegin());
    return loginAd(input)
      .then(json => {
        dispatch(loginSuccess(json));
        return json;
      })
      .catch(error =>
        dispatch(loginFail(error))
      );
  };
}


export function createUser(input) {

  return dispatch => {
    dispatch(createUserBegin());
    return createEwUser(input)
      .then(json => {
        dispatch(createUserSuccess(json));
        return json;
      })
      .catch(error =>
        dispatch(createUserFailure(error))
      );
  };
}

export function updateUser(input) {

  return dispatch => {
    dispatch(updateUserBegin());
    return updateEwUser(input)
      .then(json => {
        dispatch(updateUserSuccess(json));
        return json;
      })
      .catch(error =>
        dispatch(updateUserFailure(error))
      );
  };
}


export function uploadUsers(input) {

  return dispatch => {
    dispatch(uploadUserBegin());
    return uploadUserFile(input)
      .then(json => {
        dispatch(uploadUsersSuccess(json));
        return json;
      })
      .catch(error =>
        dispatch(uploadUsersFail(error))
      );
  };
}

export function validateToken(input) {
  return dispatch => {
    dispatch(validateTokenBegin());
    return validatePwToken(input)
      .then(json => {
        dispatch(validateTokenSuccess(json));
        return json;
      })
      .catch(error =>
        dispatch(validateTokenFail(error))
      );
  };
}

export function resetPassword(input) {
  return dispatch => {
    dispatch(resetPasswordBegin());
    return resetAdPassword(input)
      .then(json => {
        dispatch(resetPasswordSuccess(json));
        return json;
      })
      .catch(error =>
        dispatch(resetPasswordFail(error))
      );
  };
}


export function deleteUser(input) {
  return dispatch => {
    dispatch(delUserBegin());
    return deleteEwUser(input)
      .then(json => {
        dispatch(delUserSuccess(json));
        return json;
      })
      .catch(error =>
        dispatch(delUserFail(error))
      );
  };
}

async function intialize(dispatch){
    let getusers = dispatch(getUsers())
    let getgroups = dispatch(fetchEwGroups())
    let getcomps = dispatch(fetchEwCompanies())

    return Promise.all([getusers, getgroups, getcomps])
}

export function intializeUam() {
  return dispatch => {
    dispatch(showSpinner('Fetching Users'))
    intialize(dispatch)
    .then(() => {
      dispatch(clearCos())
      dispatch(clearGroups())
      dispatch(clearRoles())
      dispatch(hideSpinner())
    })
  }
}

/*export function intializeUam() {
  return dispatch => {
    dispatch(showSpinner('Fetching Users'))
    dispatch(getUsers())
      .then(() => {
        dispatch(showSpinner('Fetching Groups'))
        dispatch(fetchEwGroups())
          .then(() => {
            dispatch(showSpinner('Fetching Accounts'))
            dispatch(fetchEwCompanies())
              .then(() => {
                dispatch(clearCos())
                dispatch(clearGroups())
                dispatch(clearRoles())
                dispatch(hideSpinner())
              })
          })
      })
  }
}*/

function handleErrors(response) {
  if (response.status != 200) {
    throw Error(response.statusText);
  }
  return response;
}

